const testCondition = ({
  fieldValue,
  operator,
  value,
}: {
  fieldValue: any;
  operator: string;
  value: any;
}): boolean => {
  switch (operator) {
    case '==': {
      if (undefined === fieldValue) {
        return false;
      }

      switch (typeof fieldValue) {
        case 'string': {
          return Boolean(0 === String(fieldValue).localeCompare(value));
        }

        case 'number':
        default: {
          return Boolean(fieldValue === value);
        }
      }
    }

    case '!=': {
      if (undefined === fieldValue) {
        return false;
      }

      switch (typeof fieldValue) {
        case 'string': {
          return Boolean(0 !== String(fieldValue).localeCompare(value));
        }

        case 'number':
        default: {
          return Boolean(fieldValue !== value);
        }
      }
    }

    case '>': {
      if (undefined === fieldValue) {
        return false;
      }

      if (!Number.isNaN(Number(value)) && Number.isNaN(Number(fieldValue))) {
        return false;
      }

      return Boolean(fieldValue > value);
    }

    case 'in': {
      const newArray =
        value && !Array.isArray(value) ? value.split(',') : value;

      return undefined !== fieldValue && Boolean(newArray.includes(fieldValue));
    }

    case 'is': {
      return (
        undefined !== fieldValue &&
        (('string' === typeof fieldValue &&
          fieldValue !== 'false' &&
          Boolean(fieldValue)) ||
          (Array.isArray(fieldValue) && fieldValue.length > 0))
      );
    }

    case 'not': {
      return (
        !fieldValue || (Array.isArray(fieldValue) && 0 === fieldValue.length)
      );
    }

    case 'not-in': {
      const newArray =
        value && !Array.isArray(value) ? value.split(',') : value;

      return !fieldValue || !newArray.includes(fieldValue);
    }
  }

  return false;
};

export default testCondition;
